<template>
    <div>
        <div class="clearfix row py-2 mb-2 mt-3 no-margin"> <!-- Mustafijur: 19-05-2026: Removed: border-bottom-->


            <div class="col-sm-4 pl-0 leave-search-mobile">
                <div class="custom-search ess-leave-list">
                    <b-input-group class="mb-0">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search.." v-model="search"
                            @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
            </div>

            <div class=" col-sm-8 text-right pr-0 leave-filter-mobile">
                <template>
                    <template>
                        <!-- Disabled in ESS by Ali
                        <b-button class="custom-primary" :href="$api_url+'/employee/leave/import/template'" v-if="flg != 1"> Template </b-button>
                        <b-button class="custom-primary" :href="$api_url+'/employee/leave/import/upload'"> Import </b-button>

                    -->
                        <b-button id="show-btn" class="" @click="addNew()">Add New Leave</b-button>
                    </template>
                    <b-button class="employee-filter-btn custom-secodary-btn mt-2 mt-md-0"
                        v-b-toggle.sidebar_right_1>Filter</b-button>
                </template>

            </div>
        </div>

        <div class="row justify-content-center no-margin employee-table-wrapper">
            <div class="col-sm-12  px-0">
                <b-overlay :show="showoverlay_list" rounded="sm">
                    <table class="table dataTable table-responsive">
                        <thead class="" style="">
                            <tr class="table-head">
                                <td class="" v-for="column in columns" :key="column.name" @click="sortBy(column.name)"
                                    :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                    style="cursor:pointer;">

                                    <template v-if="column.name != 'to' && column.name != 'from'">
                                        <label class="custom-label"><span>{{ column.label }}</span></label>
                                    </template>
                                    <template v-else>
                                        <label class="custom-label"><span> {{ column.label }}</span>
                                            <div class="table-header">
                                                <div class="table sub-header">(YYYY-MM-DD)</div>
                                            </div>
                                        </label>
                                    </template>
                                </td>
                                <!-- Abdullah: text-center -->
                                <td class="text-center" v-if="ce">
                                    <label class="custom-label"><span>Action</span></label>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(leave, n) in paginatedData">
                                <tr class="table-row hover-bg" :key="n">
                                    <td class="employee-info-cell">
                                        <div class="img-holder">
                                            <img v-if="leave.employee_pic != ''"
                                                v-bind:src="'/avatar/' + leave.company_id + '/' + leave.employee_pic"
                                                class="img-fluid img-thumbnail employee-avatar mr-2" />
                                            <img v-else v-bind:src="'/avatar/demo.jpg'"
                                                class="img-fluid img-thumbnail employee-avatar mx-2" />
                                        </div>
                                        <div class="name-holder">
                                            {{ leave.employee_name }}<br />
                                            <span class="txt-alt">{{ leave.employee_code }}</span>
                                        </div>
                                    </td>
                                    <td class="">
                                        {{ leave.department }}
                                    </td>
                                    <td class="">
                                        {{ leave.jobposition }}
                                    </td>

                                    <td>
                                        <div class="d-flex flex-column align-items-start">
                                            <img v-if="leave.leave_type == 'Sick Leave'"
                                                :src="$api_url + '/images/menu/hospital.svg'" class="mb-2" />

                                            <img v-else-if="leave.leave_type == 'Casual Leave'"
                                                :src="$api_url + '/images/menu/plane.png'" class="mb-2" />

                                            <img v-else :src="$api_url + '/images/menu/clock.png'" class="mb-2" />

                                            <span>{{ leave.leave_type }}</span>
                                        </div>
                                    </td>
                                    <td class="">
                                        {{ leave.from }}
                                    </td>
                                    <td class="">
                                        {{ leave.to }}
                                    </td>
                                    <td class="">

                                        <template v-if="leave.leave_day == 0">
                                            {{ leave.number_of_days }}
                                            <span v-if="leave.number_of_days > 1">days</span>
                                            <span v-else>day</span>
                                        </template>
                                        <template v-else-if="leave.leave_day == 1">First Half</template>
                                        <template v-else-if="leave.leave_day == 2">Second Half</template>
                                        <!-- {{leave.number_of_days}}
                                    <span v-if="leave.number_of_days > 1">days</span>
                                    <span v-else>day</span> -->
                                    </td>
                                    <td class="leave-reason-wrapper">
                                        {{ leave.reason }} <br />
                                        <b-link v-if="leave.attachment != null"
                                            @click="downloadFileContent('/images/employee/' + leave.company_id + '/leaves/' + leave.attachment)"><img
                                                :src="$api_url + '/images/download_image.png'" class="" /> </b-link>



                                    </td>
                                    <td class="">
                                        {{ leave.updated_by }}
                                    </td>

                                    <!-- Abdullah responsive added text-right  -->
                                    <td class="position-relative text-right" v-if="ce">
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                            style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false"><b-icon
                                                icon="three-dots-vertical"></b-icon></a>
                                        <div class="dropdown-menu action-dropdown-menu"
                                            aria-labelledby="actionDropdown">
                                            <b-button-toolbar class="">
                                                <b-button-group class="mr-0">

                                                    <!-- Disabled in ESS by Ali
                                                <b-button class="mr-3 rounded edit-btn" v-if="!manager" title="Edit" @click="editLeave(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to)">
                                                    <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                                </b-button>
                                                -->
                                                    <b-button class="mr-3 rounded edit-btn" title="Approve"
                                                        v-if="leave.flg_status == 0"
                                                        @click="updateLeave(leave.employee_id, leave.leave_type_id, leave.flg_status, leave.from, leave.to, 1)">
                                                        <b-icon icon="check" class="mr-2"
                                                            aria-hidden="true"></b-icon>Approve
                                                    </b-button>

                                                    <b-button class="mr-3 rounded edit-btn" title="Reject"
                                                        v-if="leave.flg_status == 0"
                                                        @click="updateLeave(leave.employee_id, leave.leave_type_id, leave.flg_status, leave.from, leave.to, 2)">
                                                        <b-icon icon="x" class="mr-2" aria-hidden="true"></b-icon>Reject
                                                    </b-button>

                                                    <!--<b-button class="rounded delete-btn" title="Delete" @click="deleteLeave(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to)">editLeave
                                                    <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                </b-button>-->
                                                </b-button-group>
                                            </b-button-toolbar>
                                        </div>

                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>


                    <div v-if="paginatedData.length == 0" class="list-no-data">
                        No records found.
                    </div>
                    <div v-else class="">
                        <!-- <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ><template #prev-text><span>Previous</span></template><template #next-text><span>Next</span></template></b-pagination-nav>
                        -->
                        <div class="clearfix mt-2 mb-4">
                            <ul class="pagination b-pagination float-left mb-0 mt-1">
                                <li class="page-item disabled m-2">View</li>
                                <li class="page-item disabled"><b-form-select v-model="temp_length"
                                        :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                <li class="page-item disabled m-2">per page. Total {{ people }} records found.</li>
                            </ul>
                            <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                                :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#"
                                first-number last-number></b-pagination-nav>

                        </div>
                    </div>
                </b-overlay>
            </div>
        </div>


        <b-sidebar id="sidebar_right_1" title="Filter" right shadow>
            <template v-slot:default="{ hide }">
                <div class="px-3 py-2 filter-wrapper">
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <select name="department_id" class='form-control' v-model='search_by_id.department_id'>
                            <option value='0'>Select Department</option>
                            <option v-for='data in depertments' :value='data.id'>{{ data.name }}</option>
                        </select>
                    </b-input-group>

                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <select name="jobposition_id" class='form-control' v-model='search_by_id.jobposition_id'>
                            <option value='0'>Select Job Position</option>
                            <option v-for='data in jobtypes' :value='data.id'>{{ data.name }}</option>
                        </select>
                    </b-input-group>

                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="list"></b-icon>
                        </b-input-group-prepend>
                        <select name="department_id" class='form-control' v-model='search_by_id.leave_type_id'>
                            <option value='0'>Select Leave Type</option>
                            <option v-for='data in leavetypes' :value='data.id'>{{ data.title }}</option>
                        </select>
                    </b-input-group>

                    <!--
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="list"></b-icon>
                            </b-input-group-prepend>
                            <select name="flg_status" class='form-control' v-model='search_by_id.flg_status'>
                                <option value='-1' >Select Leave Status</option>
                                <option v-for='data in flg_status' :value='data.value'>{{ data.text }}</option>
                            </select>
                        </b-input-group>
                    -->



                    <b-form-group id="day_one-group" label="From [YYYY-MM-DD]" label-for="day_one_text" class="mt-4">
                        <b-input-group class="mb-3">
                            <b-form-input id="day_one_text" name="day_one_text" v-model="day_one"
                                v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                @change="updateToDate"></b-form-input>
                            <b-input-group-append>
                                <b-form-datepicker id="day_one" @context="updateToDate()" button-only right
                                    locale="en-US" v-model="day_one" :date-disabled-fn="dateDisabled"
                                    :start-weekday="fetchStartWeekday"></b-form-datepicker>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>


                    <b-form-group id="day_two-group" label="To [YYYY-MM-DD]" label-for="day_two_text">
                        <b-input-group class="mb-3">
                            <b-form-input id="day_two_text" name="day_two_text" v-model="day_two"
                                v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                @change="checkValidDate"></b-form-input>

                            <b-input-group-append>
                                <b-form-datepicker id="day_two" button-only right locale="en-US" :min="min"
                                    v-model="day_two" :date-disabled-fn="dateDisabled"
                                    :start-weekday="fetchStartWeekday"></b-form-datepicker>
                            </b-input-group-append>


                        </b-input-group>
                    </b-form-group>


                    <div class="mt-4 row">
                        <div class="col-6">
                            <b-button class="btn filter_btn btn-primary btn-block not-collapsed" variant="primary" block
                                title="Set Filter" @click="setFlter();">
                                Set Filter
                            </b-button>
                        </div>
                        <div class="col-6">
                            <b-button class="btn filter_btn btn-primary btn-block not-collapsed" variant="primary" block
                                title="Clear Filter" @click="resetFlter();">
                                Clear Filter
                            </b-button>
                        </div>


                    </div>


                </div>
            </template>
        </b-sidebar>


        <!--- search employee and add leave --->
        <b-modal id="bv-modal-add-leave" size="lg" scrollable hide-footer title="Leave Details" dialog-class="w-1000">
            <!-- Mustafijur: 18-05-2026 -->
            <search-employees-front v-if="this.employee_id == 0" :flg="1"
                v-on:childToParent="setEmployee"></search-employees-front>
            <employee-leave-details-front v-if="this.employee_id > 0" :editflg="0"
                v-on:childToParent="getLeaves"></employee-leave-details-front>
        </b-modal>
        <!-- update leave data -->
        <b-modal id="bv-modal-edit-leave" size="xl" scrollable hide-footer title="Leave Details">
            <!-- leave_type_id , flg_status , from , to -->

            <employee-leave-details-front v-if="this.employee_id > 0" :editflg="1"
                :leave_type_id="this.tmp_leave_type_id" :flg_status="this.tmp_flg_status" :from="this.tmp_from"
                :to="this.tmp_to" v-on:childToParent="getLeavesNew"></employee-leave-details-front>
        </b-modal>


        <b-modal id="bv-modal-import-leave" scrollable hide-footer title="Import Leaves">
            <b-overlay :show="showoverlay" rounded="sm" class="">
                <b-form-file id="datafile" name="datafile" @change="checkFileType($event, 'datafile', ['.xls', '.xlsx'])" accept=".xlsx,.xls"></b-form-file>
                <!--<b-button type="button" v-if="has_file" @click="checkFileData" variant="primary" size="lg">Validate file data</b-button>
                <b-button type="button" v-if="has_file" @click="processFileData" variant="primary" size="lg">Process file data</b-button>-->


                <div v-if='errormsg'>
                    <div v-if="errormsg.length > 0" class="alert alert-danger my-3">Total error {{ errormsg.length }}
                    </div>
                    <ul class="list-group ">
                        <li class="list-group-item list-group-item-danger" v-for='error in errormsg'>{{ error }}</li>
                    </ul>
                </div>
            </b-overlay>
        </b-modal>
    </div>
</template>
<script>
import moment from 'moment'
export default {

    mounted() {
        if (this.check_ce == 1) {
            if (this.ce_flg == 1)
                this.ce = true;
            else
                this.ce = false;

        }
    },
    props: ['flg', 'manager'],
    components: {},
    data() {
        /** Sohel Code Starts Here */
        let sortOrders = {};
        let columns = [
            { label: 'Employee', name: 'employee_name' },
            { label: 'Department', name: 'department' },
            { label: 'Job Position', name: 'jobposition' },
            { label: 'Leave Type', name: 'leave_type' },
            { label: 'From', name: 'from' },
            { label: 'To', name: 'to' },
            { label: 'No. of Days', name: 'number_of_days' },
            { label: 'Reason', name: 'reason' },
            { label: 'Updated By', name: 'updated_by' },
        ];
        columns.forEach((column) => { sortOrders[column.name] = -1; });
        /** Sohel Code Ends Here */

        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        const minDate = new Date(today);
        minDate.setMonth(minDate.getMonth());
        minDate.setDate(minDate.getDate());
        const startdate = minDate;
        var startDate = '';
        var endDate = '';
        //var today = new Date();
        if ((today.getMonth() + 1) <= 6) {
            startDate = (today.getFullYear() - 1) + '-07-1';
            endDate = (today.getFullYear()) + '-06-30';
        }
        else {
            startDate = (today.getFullYear()) + '-07-1';
            endDate = (today.getFullYear() + 1) + '-06-30';
        }

        return {
            depertments: [],
            jobtypes: [],
            search_by_id: { department_id: 0, jobposition_id: 0, leave_type_id: 0, flg_status: 0 },
            startDate: startDate,
            endDate: endDate,
            min: minDate,
            day_one: moment(String(startdate)).format('YYYY-MM-DD'),
            day_two: moment(String(startdate)).format('YYYY-MM-DD'),
            week_holidays: [6],
            all_week_holidays: [6],
            week_start_day: 7,
            holidays_date_arr: [],
            leavetypes: [],
            flg_status: [
                { text: 'Applied', value: '0' },
                { text: 'Approved', value: '1' },
                { text: 'Declined', value: '2' },
            ],

            /** Sohel Code Starts Here */
            columns: columns,
            sortKey: 'employee_name',
            sortOrders: sortOrders,
            /** Sohel Code Ends Here */

            leaves: [],

            showoverlay: false,
            showoverlay_list: false,
            movenext: false,

            errormsg: [],
            fdata: {},

            search: '',
            length: 20,
            pagination: { currentPage: 1, pages: 1 },
            temp_length: 20,
            length_options: [],
            people: 0,

            ce: true,
            employee_id: 0,

            approved_leaves_today: 0,
            pending_leaves_today: 0,
            pending_leaves_fiscal_year: 0,


            tmp_leave_type_id: 0,
            tmp_flg_status: 0,
            tmp_from: '',
            tmp_to: '',


            start_date: null,
            end_date: null,
            lv: [],
            this_month_holidays: [],
            this_month: 1,
            this_year: 2020,
            weekly_holidays: [6],
            first_day_of_week: 7,
            total_working_day: 0,
            total_weekends: 0,
            total_holidays: 0,
            weekend_color_code: '#aaaaaa',
            holiday_color_code: '#aaaaaa',

        }
    },
    methods: {
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },

        importLeaves: function () {
            this.$bvModal.show('bv-modal-import-leave');
        },

        getLeavesNew: function () {
            //this.showoverlay_list = true;
            if (!this.checkNet()) return false;

            if (this.flg == 0)
                this.employee_id = 0;


            this.$bvModal.hide('bv-modal-leave-details');
            let currentObj = this;
            this.search_by_id.flg_status = 0;
            axios.get(this.$api_url + '/front/employees/leaves/fiscalyear?flg=' + this.flg, {
                params: {
                    search_by_id: this.search_by_id
                }
            }).then(function (response) {

                this.leaves = response.data.leaves;
                this.employee_id = response.data.employee_id;

                this.approved_leaves_today = response.data.approved_leaves_today;
                //this.pending_leaves_today = response.data.pending_leaves_today;
                this.pending_leaves_fiscal_year = response.data.pending_leaves_today;
                this.$emit('childToParent');

                setTimeout(function () {
                    this.showoverlay_list = false;
                }.bind(this), 1000);



                this.$bvModal.hide('bv-modal-edit-leave');
                this.$bvModal.hide('bv-modal-add-leave');
                //console.log(this.leaves);


            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },

        getLeaves: function () {
            this.showoverlay_list = true;
            if (!this.checkNet()) return false;

            if (this.flg == 0)
                this.employee_id = 0;


            this.$bvModal.hide('bv-modal-leave-details');
            let currentObj = this;
            this.search_by_id.flg_status = 0;
            axios.get(this.$api_url + '/front/employees/leaves/fiscalyear?flg=' + this.flg, {
                params: {
                    search_by_id: this.search_by_id
                }
            }).then(function (response) {
                this.showoverlay_list = false;
                this.leaves = response.data.leaves;
                this.employee_id = response.data.employee_id;

                this.approved_leaves_today = response.data.approved_leaves_today;
                //this.pending_leaves_today = response.data.pending_leaves_today;
                this.pending_leaves_fiscal_year = response.data.pending_leaves_today;


                this.$bvModal.hide('bv-modal-edit-leave');
                this.$bvModal.hide('bv-modal-add-leave');
                //console.log(this.leaves);


            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },

        getApprovePendingLeavesToday: function () {
            if (!this.checkNet()) return false;

            let currentObj = this;
            axios.get(this.$api_url + '/front/approve-pending/leaves/today', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.approved_leaves_today = response.data.approved_leaves_today;
                this.pending_leaves_today = response.data.pending_leaves_today;
                this.pending_leaves_fiscal_year = response.data.pending_leaves_fiscal_year;


            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        setEmployee: function (x) {
            this.employee_id = x.employee_id;
        },
        addNew() {
            if (this.flg == 0)
                this.employee_id = 0;

            this.$bvModal.show('bv-modal-add-leave');
        },

        //editLeave(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to)
        editLeave: function (employee_id, leave_type_id, flg_status, from, to) {
            if (!this.checkNet()) return false;
            let currentObj = this;
            this.employee_id = 0;
            let formData = new FormData();
            formData.append('employee_id', employee_id);
            axios.post(this.$api_url + '/front/employee/setemployee', formData)
                .then(function (response) {
                    this.employee_id = employee_id;

                    this.tmp_leave_type_id = leave_type_id;
                    this.tmp_flg_status = flg_status;
                    this.tmp_from = from;
                    this.tmp_to = to;

                    this.$bvModal.show('bv-modal-edit-leave');

                }.bind(this))
                .catch(function (error) {
                    currentObj.showoverlay = false;
                    currentObj.serverError(error);
                });

        },
        updateLeave: function (employee_id, leave_type_id, flg_status, from, to, status) {
            if (!this.checkNet()) return false;
            let currentObj = this;
            this.employee_id = 0;
            this.showoverlay_list = true;
            let formData = new FormData();
            formData.append('employee_id', employee_id);
            formData.append('leave_type_id', leave_type_id);
            formData.append('flg_status', flg_status);
            formData.append('from', from);
            formData.append('to', to);
            formData.append('status', status);

            axios.post(this.$api_url + '/front/employee/leaves/status', formData)
                .then(function (response) {
                    this.getLeavesNew();

                    //this.showoverlay_list = false;
                }.bind(this))
                .catch(function (error) {
                    currentObj.showoverlay = false;
                    this.showoverlay_list = false;
                    currentObj.serverError(error);
                });

        },
        deleteLeave: function (employee_id, leave_type_id, flg_status, from, to) {
            let formData = new FormData();
            formData.append('employee_id', employee_id);
            formData.append('leave_type_id', leave_type_id);
            formData.append('from', from);
            formData.append('to', to);
            formData.append('flg_status', flg_status);



            axios.post(this.$api_url + '/front/leave/delete/range', formData)
                .then(function (response) {
                    this.$bvToast.toast('Deleted!', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });


                    this.getLeaves();
                    //this.getApprovePendingLeavesToday();

                }.bind(this))
                .catch(function (error) {
                    currentObj.showoverlay = false;
                    currentObj.serverError(error);
                });
        },



        getDepertments: function () {
            axios.get(this.$api_url + '/front/department/list')
                .then(function (response) {
                    this.depertments = response.data;
                }.bind(this));

        },
        getJobTypes: function () {
            axios.get(this.$api_url + '/front/jobposition/options', {
                params: {

                }
            }).then(function (response) {
                this.jobtypes = response.data;
            }.bind(this));
        },

        dateDisabled(ymd, date) {
            const x = moment(String(date)).format('YYYY-MM-DD');
            const weekday = date.getDay();
            const day = date.getDate();
            return this.all_week_holidays.includes(weekday) || this.holidays_date_arr.includes(x);
        },
        updateToDate: function () {
            if (this.fake == 1) return;
            this.day_two = this.day_one;
            this.min = this.day_one;
        },
        checkValidDate: function () {
            if (moment(this.day_two).isBefore(moment(this.day_one).format('YYYY-MM-DD')))
                this.updateToDate();
        },

        getDisabledDates: function () {
            axios.get(this.$api_url + '/front/holidays/details', {
                params: {
                    //id: x
                }
            }).then(function (response) {

                if (response.data.length != 0) {
                    this.all_week_holidays = response.data.report.week_holidays;
                    this.week_holidays = response.data.report.week_holidays.split(',');
                    this.week_start_day = response.data.report.week_start_day;
                    this.holidays_date_arr = response.data.report.holidays_date_arr.split(',').map(function (item) { return item; });
                }
            }.bind(this));
        },
        getLeaveTypes: function () {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/front/leave/types', {

            }).then(function (response) {

                this.leavetypes = response.data;
            }.bind(this));
        },

        resetFlter: function () {
            this.day_one = '';
            this.day_two = '';

            this.search_by_id.day_one = '';
            this.search_by_id.day_two = '';
            this.search_by_id.department_id = 0;
            this.search_by_id.jobposition_id = 0;
            this.search_by_id.leave_type_id = 0;
            this.search_by_id.flg_status = 0;
            this.getLeaves();
            this.$root.$emit('bv::toggle::collapse', 'sidebar_right_1');
        },
        setFlter: function () {
            this.search_by_id.day_one = this.day_one;
            this.search_by_id.day_two = this.day_two;
            this.getLeaves();
            this.$root.$emit('bv::toggle::collapse', 'sidebar_right_1');
        }






    },
    created: function () {

        this.getDepertments();
        this.getJobTypes();
        this.getLeaveTypes();
        this.resetFlter();
        //this.getEmployeeLeaveSettings();
        this.getDisabledDates();
        //this.getApprovePendingLeavesToday();
        //Fire.$on('reloadUsers', () => {this.getLeaves()});
    },
    computed:
    {
        filteredData() {
            let filtered_list = this.leaves;
            this.people = this.leaves.length;
            this.length_options = [{ value: 10, text: "10" }, { value: 20, text: "20" },
            { value: 50, text: "50" },
            { value: 100, text: "100" },
            { value: 200, text: "200" },
            { value: 500, text: "500" },
            { value: this.leaves.length, text: "All" }];
            if (this.search) {

                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });

                if (filtered_list.length == 0)
                    this.blankmsg = "Nothing found.";
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;
            if (sortKey) {
                filtered_list = filtered_list.slice().sort((a, b) => {
                    let index = this.getIndex(this.columns, 'name', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    if (this.columns[index].type && this.columns[index].type === 'date') {
                        return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                    }
                    else if (this.columns[index].type && this.columns[index].type === 'number') {
                        return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                    }
                    else {
                        return (a === b ? 0 : a > b ? 1 : -1) * order;
                    }
                }
                );
            }

            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },

        fetchStartWeekday() {
            return this.week_start_day;
        },
    }
}
</script>
<style scoped>
.img-holder {
    cursor: not-allowed;
    pointer-events: none;
}
</style>
